// extracted by mini-css-extract-plugin
module.exports = {"box":"box___2fU6P","flex":"flex___2qYB2","url":"url___1Igny","boxer":"boxer___kQHTl"};